import React from "react"
import { useToast } from "@/hooks/use-toast"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useUsers } from "@/lib/contexts/user-context"
import { router, usePage } from "@inertiajs/react"

export function LogoutConfirmModal({ open, onClose }) {
  const { toast } = useToast()
  const { currentUser: contextCurrentUser, setCurrentUser } = useUsers()
  const { props } = usePage()
  // Use props.user (from Inertia) which is always up-to-date, fallback to context
  const currentUser = props.user || contextCurrentUser

  const handleLogout = () => {
    // Call the backend logout endpoint
    router.post('/logout', {}, {
      onSuccess: () => {
        // Clear all local storage items
        localStorage.clear()
        
        // Remove authentication state and current user
        setCurrentUser(null)

        // Show toast notification
        toast({
          title: "Logged out successfully",
          description: "You have been logged out of your account.",
        })

        // Redirect to login page
        router.visit("/login")
        onClose()
      },
      onError: (errors) => {
        toast({
          title: "Logout failed",
          description: "An error occurred while logging out.",
          variant: "destructive",
        })
      }
    })
  }

  if (!currentUser) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader className="flex flex-col items-center text-center">
          {/* <div className="flex items-center justify-center mb-2 text-primary"> */}
            {/* <img 
              src="/images/icons/dme-favicon.png" 
              alt="DME Logo" 
              className="h-8 w-8"
            /> */}
            {/* <span className="ml-2 text-xl font-semibold">DME</span>
          </div> */}
          <DialogTitle className="text-xl">Log out of your account</DialogTitle>
          <DialogDescription>You will need to log in again to access your account.</DialogDescription>
        </DialogHeader>

        <div className="flex flex-col items-center py-4">
          <Avatar className="h-16 w-16 mb-4">
            <AvatarImage 
              src={currentUser?.avatar} 
              alt={`${currentUser.firstName} ${currentUser.lastName}`} 
              className="object-cover"
            />
            <AvatarFallback className="text-lg bg-primary text-white">
              {currentUser.firstName[0]}
              {currentUser.lastName[0]}
            </AvatarFallback>
          </Avatar>
          <h3 className="text-lg font-medium">{`${currentUser.firstName} ${currentUser.lastName}`}</h3>
          <p className="text-sm text-muted-foreground">{currentUser.email}</p>
        </div>

        <DialogFooter className="flex flex-col space-y-2 sm:space-y-0">
          <Button onClick={handleLogout} className="w-full dark:text-white">
            Log out
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full">
            Cancel
          </Button>
        </DialogFooter>

        <div className="mt-4 pt-4 border-t text-center text-xs text-muted-foreground">
          <p>DME © {new Date().getFullYear()}</p>
        </div>
      </DialogContent>
    </Dialog>
  )
}
